import { useEffect } from 'react';
import { useSiteConfig } from '@/hooks/useSiteConfig';

const DynamicFavicon = () => {
  const { getConfig } = useSiteConfig();

  useEffect(() => {
    const faviconUrl = getConfig('favicon_url');
    
    if (faviconUrl) {
      // Remove existing favicon links
      const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
      existingFavicons.forEach(link => link.remove());

      // Create new favicon link
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = faviconUrl;
      link.type = 'image/png';
      
      document.head.appendChild(link);
    }
  }, [getConfig]);

  return null;
};

export default DynamicFavicon;